module.exports = __webpack_public_path__ + "static/media/product3.bdc34660.png";